import { forwardRef, type Ref, type SVGProps } from "react";
const IconAwardRibbonFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="m29.8 23.66-3.27-4.45a12.52 12.52 0 0 1-8.31 5.58l3.54 4.8a1 1 0 0 0 .8.4h.08a1 1 0 0 0 .8-.54l1.81-3.53 3.92-.68a1 1 0 0 0 .63-1.58M5.47 19.21 2.2 23.66a1 1 0 0 0 .63 1.58l3.91.68 1.8 3.53a1 1 0 0 0 .82.55h.08a1 1 0 0 0 .8-.4l3.54-4.8a12.52 12.52 0 0 1-8.3-5.59zm19.77-1.73a10.5 10.5 0 1 0-10.15 5.47 10.6 10.6 0 0 0 1.82 0 10.52 10.52 0 0 0 8.33-5.47m-11.61-.1c-.59.3-1 .01-.9-.63l.37-2.78-1.85-2c-.44-.48-.28-.97.37-1.09l2.58-.48 1.26-2.46c.3-.58.78-.58 1.08 0l1.26 2.46 2.59.48c.64.12.8.61.36 1.09l-1.84 2 .37 2.78c.09.64-.32.93-.9.63L16 16.18z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconAwardRibbonFilledSVG);
ForwardRef.displayName = "IconAwardRibbonFilled";
export { ForwardRef as IconAwardRibbonFilled };
